import { Transaction } from "@codemirror/state";
import type { EditorView } from "@codemirror/view";

import { setClipboardText } from "@/copyPaste";
import { withHardBreaks } from "@/utils/text/lineBreaker";
import { maxStickyTextLength } from "@/utils/text/sticky";

export function useCopyPaste(hardBreaks: boolean) {
  const maxLen = maxStickyTextLength();

  function copy(event: ClipboardEvent, view: EditorView) {
    const selection = view.state.selection.main;
    setClipboardText(event, view.state.sliceDoc(selection.from, selection.to));
  }

  function paste(event: ClipboardEvent, view: EditorView) {
    event.preventDefault();
    let text = event.clipboardData?.getData("text/plain");
    if (text) {
      text = withHardBreaks(text, hardBreaks);
      const state = view.state;
      const selection = state.selection.main;
      const available = maxLen - (state.doc.length - (selection.to - selection.from));
      if (available > 0) {
        view.dispatch(state.replaceSelection(text.slice(0, available)));
      }
    }
    return true;
  }

  function maxLength(tr: Transaction) {
    // accept non-user changes (set initial value, rebreak text)
    if (tr.annotation(Transaction.remote) === true) {
      return true;
    }
    const len = tr.newDoc.length;
    // accept deletions in a too long text
    return len <= maxLen || len <= tr.startState.doc.length;
  }

  return { copy, paste, maxLength };
}
